import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const OfficeFormsLogo24Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1365 1707v-512h512v512h-512zm86-427v341h341v-341h-341zm128-427q-62 0-116-23t-95-64-64-95-24-116q0-62 23-116t64-95 95-64 117-24q62 0 116 23t94 64 64 95 24 117q0 62-23 116t-64 94-95 64-116 24zm0-512q-44 0-83 17t-68 46-46 68-17 83q0 44 17 82t46 68 68 46 83 17q44 0 82-17t68-46 46-67 17-83q0-44-17-83t-46-68-67-46-83-17zm384-256q18 0 33 7t27 18 18 27 7 34v1706q0 18-6 33t-18 27-27 19-34 7H597q-18 0-33-7t-27-18-18-27-7-34v-256H100q-42 0-71-28t-29-71V526q0-42 29-70t71-29h412V171q0-18 6-33t18-27 27-19 34-7h1366zM597 171v256h498q42 0 71 28t29 71v413h768V171H597zm-101 940h276V958H496V815h296V661H320v726h176v-276zm101 766h1366v-853h-768v498q0 42-29 70t-71 29H597v256z" />
    </svg>
  ),
  displayName: 'OfficeFormsLogo24Icon',
});

export default OfficeFormsLogo24Icon;
